import React from "react";

// reactstrap components
import {
  Card,
  CardBody,
  CardFooter,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components

function SectionHeader() {
  return (
    <>
      <div className="section section-feature cd-section" id="features">
        {/* ********* FEATURES 1 ********* */}
        <div className="features-1" style={{ paddingBottom: "100px" }}>
          <Container>
            <Row>
              <Col className="ml-auto mr-auto text-center" md="8">
                <h2 style={{ color: "#000000", marginTop: "30px", marginBottom: "25px", minHeight: "32px" }}>
                  Why our equipments are the best
                </h2>
                <h5 className="description" style={{ color: "#000000" }}>
                  Our equipments don't only complete the job but it surely leaves an astonishing experience.
                </h5>
              </Col>
            </Row>
            <Row>
              <Col md="3">
                <div className="info">
                  <div className="icon icon-danger">
                    <i className="nc-icon nc-palette" />
                  </div>
                  <div className="description" style={{ color: "#000000" }}>
                    <h5 className="info-title"><b>Beautiful Attire</b></h5>
                    <p className="description" style={{ color: "#000000" }}>
                      The Equipments are designed to enlighten any Event
                      with their aesthetic touch.
                    </p>
                  </div>
                </div>
              </Col>
              <Col md="3">
                <div className="info">
                  <div className="icon icon-danger">
                    <i className="nc-icon nc-bulb-63" />
                  </div>
                  <div className="description" style={{ color: "#000000" }}>
                    <h5 className="info-title"><b>Brighten the Event</b></h5>
                    <p>
                      Larger, yet dramatically thinner. More powerful, but
                      remarkably power efficient.
                    </p>
                  </div>
                </div>
              </Col>
              <Col md="3">
                <div className="info">
                  <div className="icon icon-danger">
                    <i className="nc-icon nc-chart-bar-32" />
                  </div>
                  <div className="description" style={{ color: "#000000" }}>
                    <h5 className="info-title"><b>Statistics</b></h5>
                    <p>
                      Our Past Events with our partners has statistically proved a higher successs rate in their respective field.
                    </p>
                  </div>
                </div>
              </Col>
              <Col md="3">
                <div className="info">
                  <div className="icon icon-danger">
                    <i className="nc-icon nc-sun-fog-29" />
                  </div>
                  <div className="description" style={{ color: "#000000" }}>
                    <h5 className="info-title"><b>Innovative design</b></h5>
                    <p>
                      Find unique and delightful designs related items
                      directly from our sellers.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        {/* ********* END FEATURES 1 ********* */}
        {/* ********* FEATURES 2 ********* */}
        <div className="features-2" style={{ backgroundColor: "#000000" }}>
          <Container>
            <Row>
              <Col className="ml-auto mr-auto text-center" md="8">
                <h2 style={{ color: "#ffffff", marginTop: "30px", marginBottom: "25px", minHeight: "32px" }}>
                  Is this what you are looking for?
                </h2>
                <h5 className="description" style={{ color: "#ffffff" }}>
                  Are you looking for the right production company to host your event? We have got you covered.
                </h5>
                <br />
              </Col>
            </Row>
            <Row>
              <Col md="4">
                <Card
                  data-background="image"
                  style={{
                    backgroundImage:
                      "url(" +
                      require("assets/img/landing/lights.jpg") +
                      ")",
                  }}
                >
                  <CardBody>
                    <h5 className="card-category"><b>Lights</b></h5>
                    <div className="card-icon">
                      <i className="nc-icon nc-bulb-63" />
                    </div>
                    <p className="card-description" style={{ color: "#ffffff" }}>
                      <b>
                        Our lighting system are meant to provide the smartest lighting system, with vivid and colorful rays.
                      </b>
                    </p>
                    <CardFooter>
                    </CardFooter>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card
                  data-background="image"
                  style={{
                    backgroundImage:
                      "url(" +
                      require("assets/img/landing/video.jpg") +
                      ")",
                  }}
                >
                  <CardBody>
                    <h5 className="card-category"><b>Video</b></h5>
                    <div className="card-icon">
                      <i className="nc-icon nc-button-play" />
                    </div>
                    <p className="card-description" style={{ color: "#ffffff" }}>
                      <b>
                        When it comes to videos our LED Screens
                        will support your event in displaying your ideas.
                      </b>
                    </p>
                    <CardFooter>
                    </CardFooter>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card
                  data-background="image"
                  style={{
                    backgroundImage:
                      "url(" +
                      require("assets/img/landing/audio.jpg") +
                      ")",
                  }}
                >
                  <CardBody>
                    <h5 className="card-category"><b>Audio</b></h5>
                    <div className="card-icon">
                      <i className="nc-icon nc-headphones" />
                    </div>
                    <p className="card-description" style={{ color: "#ffffff" }}>
                      <b>
                        Our speakers are built for every occassion and event delivering the best sound quality.
                      </b>
                    </p>
                    <CardFooter>
                    </CardFooter>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
        {/* ********* END FEATURES 2 ********* */}
        {/* ********* FEATURES 3 ********* */}
        <div className="features-3">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto text-center" md="8">
                <h2 style={{ color: "#000000", marginTop: "30px", marginBottom: "25px", minHeight: "32px" }}>
                  Our Sound Systems
                </h2>
                {/* <h5 className="description" style={{color:"#000000"}}>

                </h5> */}
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Row>
                  <Col md="6">
                    <div className="info info-horizontal" style={{ padding: "60px 0 60px" }}>
                      <div className="icon icon-success">
                        <i className="nc-icon nc-layout-11" />
                      </div>
                      <div className="description" style={{ color: "#000000" }}>
                        <h5 className="info-title" style={{ color: "#000000" }}><b>Variety</b></h5>
                        <p>
                          Our sound equipments ranges from speakers to microphones of different sizes
                        </p>
                      </div>
                    </div>
                    <div className="info info-horizontal" style={{ padding: "60px 0 60px" }}>
                      <div className="icon icon-warning">
                        <i className="nc-icon nc-palette" />
                      </div>
                      <div className="description" style={{ color: "#000000" }}>
                        <h5 className="info-title" style={{ color: "#000000" }}><b>Quality</b></h5>
                        <p>
                          You will not be disapointed in the sound quality of our equipments.
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info info-horizontal" style={{ padding: "60px 0 60px" }}>
                      <div className="icon icon-danger">
                        <i className="nc-icon nc-touch-id" />
                      </div>
                      <div className="description" style={{ color: "#000000" }}>
                        <h5 className="info-title" style={{ color: "#000000" }}><b>Recommended</b></h5>
                        <p>
                          due to their efficiency, our equipments is highly Recommended by our partners and other businesses who have worked with us in the past.
                        </p>
                      </div>
                    </div>
                    <div className="info info-horizontal" style={{ padding: "60px 0 60px" }}>
                      <div className="icon icon-primary">
                        <i className="nc-icon nc-delivery-fast" />
                      </div>
                      <div className="description" style={{ color: "#000000" }}>
                        <h5 className="info-title" style={{ color: "#000000" }}><b>Fast Delivery</b></h5>
                        <p>
                          It will only take a couple of days before all the equipments you need is delivered and properly installed.
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col md="6" style={{ paddingTop: "50px" }}>
                <Row>
                  <Col md="6">
                    <div className="info info-horizontal" style={{ padding: "0" }}>
                      <div className="description" style={{ color: "#000000" }}>
                        <img
                          alt="..."
                          src={require("assets/img/landing/3.jpg")}
                          width="45%"
                          style={{ padding: "30px 5px 30px" }}
                        />
                        <img
                          alt="..."
                          src={require("assets/img/landing/4.jpg")}
                          width="45%"
                          style={{ padding: "30px 5px 30px" }}
                        />
                        <img
                          alt="..."
                          src={require("assets/img/landing/15.jpg")}
                          width="45%"
                          style={{ padding: "30px 5px 30px" }}
                        />
                        <img
                          alt="..."
                          src={require("assets/img/landing/13.jpg")}
                          width="45%"
                          style={{ padding: "30px 5px 30px" }}
                        />
                        <img
                          alt="..."
                          src={require("assets/img/landing/15.jpg")}
                          width="45%"
                          style={{ padding: "30px 5px 30px" }}
                        />
                        <img
                          alt="..."
                          src={require("assets/img/landing/6.jpg")}
                          width="45%"
                          style={{ padding: "30px 5px 30px" }}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="info info-horizontal" style={{ padding: "0" }}>
                      <div className="description" style={{ color: "#000000" }}>
                        <img
                          alt="..."
                          src={require("assets/img/landing/7.jpg")}
                          width="45%"
                          style={{ padding: "30px 5px 30px" }}
                        />
                        <img
                          alt="..."
                          src={require("assets/img/landing/8.jpg")}
                          width="45%"
                          style={{ padding: "30px 5px 30px" }}
                        />
                        <img
                          alt="..."
                          src={require("assets/img/landing/9.jpg")}
                          width="45%"
                          style={{ padding: "30px 5px 30px" }}
                        />
                        <img
                          alt="..."
                          src={require("assets/img/landing/10.jpg")}
                          width="45%"
                          style={{ padding: "30px 5px 30px" }}
                        />
                        <img
                          alt="..."
                          src={require("assets/img/landing/11.jpg")}
                          width="45%"
                          style={{ padding: "30px 5px 30px" }}
                        />
                        <img
                          alt="..."
                          src={require("assets/img/landing/12.jpg")}
                          width="45%"
                          style={{ padding: "30px 5px 30px" }}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
        {/* ********* END FEATURES 3 ********* */}
        {/* ********* FEATURES 4 ********* */}
        <div className="features-4" style={{ paddingTop: "0" }}>
          <Container>
            <Row>
              <Col className="ml-auto mr-auto text-center" md="8">
                <h2 style={{ color: "#000000", marginTop: "30px", marginBottom: "25px", minHeight: "32px" }}>
                  Our Lighting Systems
                </h2>
                {/* <h5 className="description" style={{color:"#000000"}}>

                </h5> */}
              </Col>
            </Row>
            <Row>
              <Col md="6" style={{ paddingTop: "50px" }}>
                <div className="ipad-container">
                  <Row>
                    <Col md="6">
                      <div className="info info-horizontal" style={{ padding: "0" }}>
                        <div className="description" style={{ color: "#000000" }}>
                          <img
                            alt="..."
                            src={require("assets/img/landing/18.jpg")}
                            width="45%"
                            style={{ padding: "30px 5px 30px" }}
                          />
                          <img
                            alt="..."
                            src={require("assets/img/landing/19.jpg")}
                            width="45%"
                            style={{ padding: "30px 5px 30px" }}
                          />
                          <img
                            alt="..."
                            src={require("assets/img/landing/20.jpg")}
                            width="45%"
                            style={{ padding: "30px 5px 30px" }}
                          />
                          <img
                            alt="..."
                            src={require("assets/img/landing/21.jpg")}
                            width="45%"
                            style={{ padding: "30px 5px 30px" }}
                          />
                          <img
                            alt="..."
                            src={require("assets/img/landing/22.jpg")}
                            width="45%"
                            style={{ padding: "30px 5px 30px" }}
                          />
                          <img
                            alt="..."
                            src={require("assets/img/landing/23.jpg")}
                            width="45%"
                            style={{ padding: "30px 5px 30px" }}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="info info-horizontal" style={{ padding: "0" }}>
                        <div className="description" style={{ color: "#000000" }}>
                          <img
                            alt="..."
                            src={require("assets/img/landing/24.jpg")}
                            width="45%"
                            style={{ padding: "30px 5px 30px" }}
                          />
                          <img
                            alt="..."
                            src={require("assets/img/landing/25.jpg")}
                            width="45%"
                            style={{ padding: "30px 5px 30px" }}
                          />
                          <img
                            alt="..."
                            src={require("assets/img/landing/26.jpg")}
                            width="45%"
                            style={{ padding: "30px 5px 30px" }}
                          />
                          <img
                            alt="..."
                            src={require("assets/img/landing/27.jpg")}
                            width="45%"
                            style={{ padding: "30px 5px 30px" }}
                          />
                          <img
                            alt="..."
                            src={require("assets/img/landing/28.jpg")}
                            width="45%"
                            style={{ padding: "30px 5px 30px" }}
                          />
                          <img
                            alt="..."
                            src={require("assets/img/landing/29.jpg")}
                            width="45%"
                            style={{ padding: "15px" }}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col className="offset-1" md="4">
                <div className="info info-horizontal">
                  <div className="icon icon-info">
                    <i aria-hidden={true} className="nc-icon nc-atom" />
                  </div>
                  <div className="description" style={{ color: "#000000" }}>
                    <h5 className="info-title" style={{ color: "#000000" }}><b>Variety</b></h5>
                    <p>
                      We have a big variety of lighting equipments that will surely fulfill your needs.
                    </p>
                  </div>
                </div>
                <div className="info info-horizontal">
                  <div className="icon icon-success">
                    <i aria-hidden={true} className="nc-icon nc-ruler-pencil" />
                  </div>
                  <div className="description" style={{ color: "#000000" }}>
                    <h5 className="info-title" style={{ color: "#000000" }}><b>Quality</b></h5>
                    <p>
                      We look over and maintain our high quality lighting equipments which enables us to provide outstanding-  services for different events.
                    </p>
                  </div>
                </div>
                <div className="info info-horizontal">
                  <div className="icon icon-danger">
                    <i aria-hidden={true} className="nc-icon nc-tie-bow" />
                  </div>
                  <div className="description" style={{ color: "#000000" }}>
                    <h5 className="info-title" style={{ color: "#000000" }}><b>Examples {`&`} Experience</b></h5>
                    <p>
                      As you can see in our website, we have high tech inventory and the expertise to fully take care of your event.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        {/* ********* END FEATURES 4 ********* */}
        {/* ********* FEATURES 5 ********* */}
        <div
          className="features-5"
          style={{
            backgroundColor: "#ffffff",
            paddingTop: "0"
          }}
        >
          <Container>
            <Row>
              <div className="ml-auto mr-auto">
                <h2 className="text-center" style={{ color: "#000000", marginTop: "30px", marginBottom: "25px", minHeight: "32px" }}>
                  The Truss System you're looking for
                </h2>
              </div>
            </Row>
            <Row>
              <Col className="ml-auto" sm="5">
                <div className="info">
                  <img
                    alt="..."
                    src={require("assets/img/landing/31.jpg")}
                    height='auto'
                    width='100%'
                  />
                </div>
              </Col>
              <Col className="mr-auto" sm="5">
                <div className="info">
                  <img
                    alt="..."
                    src={require("assets/img/landing/32.jpg")}
                    height='auto'
                    width='100%'
                  />
                </div>
              </Col>
            </Row>
            <Row className="bottom-line">
              <Col className="ml-auto" sm="5">
                <div className="info">
                  <img
                    alt="..."
                    src={require("assets/img/landing/33.jpg")}
                    height='auto'
                    width='100%'
                  />
                </div>
              </Col>
              <Col className="mr-auto" sm="5">
                <div className="info">
                  <img
                    alt="..."
                    src={require("assets/img/landing/34.jpg")}
                    height='auto'
                    width='100%'
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        {/* ********* END FEATURES 5 ********* */}
      </div>
    </>
  );
}

export default SectionHeader;
